<template>
  <div v-if="status.hasHours" class="hall-open-status">
    <div
      class="small font-weight-bold"
      :class="status.isOpen ? 'text-success' : 'text-danger'"
    >
      <span
        class="status-dot"
        :class="status.isOpen ? 'bg-success' : 'bg-danger'"
      ></span
      >{{ status.text }}
    </div>
    <div v-if="showHours && summary" class="small text-muted">{{ summary }}</div>
  </div>
</template>
<script>
import { getOpenStatus, formatHoursSummary } from "../openingHours";

export default {
  name: "hall-open-status",
  props: {
    hall: {
      type: Object,
      default: null,
      description: "Bingo Data med open_/close_-felter",
    },
    showHours: {
      type: Boolean,
      default: true,
      description: "Vis full ukesoversikt under apen/stengt-linja",
    },
  },
  data() {
    return {
      now: new Date(),
      timer: null,
    };
  },
  computed: {
    status() {
      return getOpenStatus(this.hall, this.now);
    },
    summary() {
      return formatHoursSummary(this.hall);
    },
  },
  mounted() {
    // Oppdater «Åpen til»/«Stengt» hvert minutt uten reload
    this.timer = setInterval(() => {
      this.now = new Date();
    }, 60000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style scoped>
.status-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 6px;
  vertical-align: middle;
}
</style>
